import React, { useEffect, useState } from 'react';
import {
    deleteRebatesApi,
    postAprobarRebatesApi
} from '../../../../api/axios'
import { formatCurrencyToNumber } from '../../../../helper/publicacionHelper';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';
import { idEstadoRebate } from '../../../../helper/rebateHelper';
import MiniSpinner from "../../../General/MiniSpinner";
import "../../../Rebates/Styles/Rebates.css";
import { toast } from '../../../../utilities/appToast';
import PropTypes from 'prop-types';
import { sendOrUpdateRebate } from '../../../../utilities/ABMPublicacion/sendOrUpdateRebate';
import { validationsSubmitRebate } from '../../../../utilities/ABMPublicacion/validationsSubmitRebate';
import { ButtonsForm } from './Rebate/ButtonsForm';
import { getTopColorClass } from '../../../../utilities/ABMPublicacion/getTopColorClass';

function Rebate({ publicacion, userType, rebate, idUsuario, updateDataRebate }) {
    const DEFAULT_REBATE = {
        aCargoMegatone: 0,
        aCargoSeller: 0,
        fechaInicio: "",
        fechaVencimiento: "",
        idAdminAprueba: 0,
        idCategoryGeneraRebate: 0,
        idEstadoRebate: 0,
        idPublicacion: 0,
        idSellerAprueba: 0,
        porcentajesRebate: {
            porcentajeMegatone: 0,
            porcentajeSeller: 0,
            porcentajeTotalDescuento: 0,
        },
        precioFinal: 0,
        precioInicial: 0,
        unidades: 0,
    };
    const [isLoading, setIsLoading] = useState(false);
    const [tieneRebate, setTieneRebate] = useState(publicacion.tieneRebate);
    const [rebateState, setRebateState] = useState(DEFAULT_REBATE);

    useEffect(() => {
        const r = rebate?.rebate ?? rebate;
        const porcentajes = rebate?.porcentajesRebate ?? {
            porcentajeMegatone: 0,
            porcentajeSeller: 0,
            porcentajeTotalDescuento: 0
        };

        if (publicacion.tieneRebate && r) {
            setRebateState(prevState => ({
                ...prevState,
                idPublicacion: r.idPublicacion,
                precioInicial: Number.parseFloat(r.precioInicial),
                precioFinal: r.precioFinal,
                aCargoMegatone: Number.parseFloat(r.aCargoMegatone ?? 0),
                aCargoSeller: Number.parseFloat(r.aCargoSeller ?? 0),
                idCategoryGeneraRebate: r.idCategoryGeneraRebate,
                fechaInicio: r.fechaInicio ? r.fechaInicio.slice(0, 10) : "",
                fechaVencimiento: r.fechaVencimiento ? r.fechaVencimiento.slice(0, 10) : "",
                unidades: r.unidades,
                idAdminAprueba: r.idAdminAprueba,
                idSellerAprueba: r.idSellerAprueba,
                porcentajesRebate: {
                    porcentajeMegatone: porcentajes.porcentajeMegatone ?? 0,
                    porcentajeSeller: porcentajes.porcentajeSeller ?? 0,
                    porcentajeTotalDescuento: porcentajes.porcentajeTotalDescuento ?? 0,
                },
                idEstadoRebate: rebate?.idEstadoRebate,
                idRebate: r.id
            }));
        } else {
            const precio = publicacion.precioPromocional === "0,00" || Number.isNaN(Number.parseFloat(publicacion.precioPromocional))
                ? publicacion.precioLista
                : publicacion.precioPromocional;

            setRebateState(prevState => ({
                ...prevState,
                precioFinal: precio
            }));
        }
    }, [publicacion.tieneRebate, rebate]);




    const myChangeHandler = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setRebateState(prevState => ({ ...prevState, [name]: value }));
    };

    const myChangeAmount = async (e) => {
        e.preventDefault();

        const { name, value } = e.target;
        let valueParsed = value ? Number.parseFloat(value) : 0;
        e.target.value = valueParsed;

        const precioInicial =
            publicacion.precioPromocional === "0,00" || Number.isNaN(Number.parseFloat(publicacion.precioPromocional))
                ? publicacion.precioLista
                : publicacion.precioPromocional;

        const inicial = Number((Number.parseFloat(precioInicial.toString().replaceAll('.', '').replace(',', '.'))).toFixed(2)) || 0;

        let precioFinal = 0;
        let porcentajeTotal = 0;

        if (name === "aCargoSeller") {
            const sale = Number.parseFloat(rebateState.aCargoMegatone) + valueParsed;
            precioFinal = Number((inicial - sale).toFixed(2));
            const porcentaje = (valueParsed * 100) / inicial;
            porcentajeTotal = porcentaje + Number.parseFloat(rebateState.porcentajesRebate.porcentajeMegatone);

            setRebateState(prev => ({
                ...prev,
                aCargoSeller: valueParsed,
                precioFinal: precioFinal,
                porcentajesRebate: {
                    ...prev.porcentajesRebate,
                    porcentajeSeller: porcentaje.toFixed(2),
                    porcentajeTotalDescuento: porcentajeTotal.toFixed(2)
                }
            }));
        }

        if (name === "aCargoMegatone") {
            const sale = Number.parseFloat(rebateState.aCargoSeller) + valueParsed;
            precioFinal = Number((inicial - sale).toFixed(2));
            const porcentaje = (valueParsed * 100) / inicial;
            porcentajeTotal = porcentaje + Number.parseFloat(rebateState.porcentajesRebate.porcentajeSeller);

            setRebateState(prev => ({
                ...prev,
                aCargoMegatone: valueParsed,
                precioFinal: precioFinal,
                porcentajesRebate: {
                    ...prev.porcentajesRebate,
                    porcentajeMegatone: porcentaje.toFixed(2),
                    porcentajeTotalDescuento: porcentajeTotal.toFixed(2)
                }
            }));
        }
    };

    const onDelete = (event) => {
        event.preventDefault();
        const req = deleteRebatesApi(rebate.rebate.id);
        req.then(response => {
            toast.success("Rebate eliminado");
            setTieneRebate(false);
            setRebateState(prevState => ({
                ...DEFAULT_REBATE,
                precioFinal: publicacion.tieneRebate ? 0 : publicacion.precioLista,
                porcentajesRebate: { ...prevState.porcentajesRebate }
            }));
        }).catch(err => {
            (err.response?.data?.errors)
            ? err.response?.data.errors?.forEach(error => toast.error(error.message))
            : toast.error("No pudo eliminarse");
        });
    };

    const onChangeState = (event) => {
        event.preventDefault();
        setIsLoading(true);


        let request = {
            idRebate: rebate.rebate?.id,
            idUsuario: idUsuario,
        };

        switch (event.target.name) {
            case "aprove":
                request.idEstado = idEstadoRebate.aprobado;
                break;
            case "sellerAprove":
                request.idEstado = idEstadoRebate.aprobadoPorSeller;
                break;
            case "decline":
                request.idEstado = idEstadoRebate.rechazado;
                break;
            default:
                break;
        }

        const req = postAprobarRebatesApi(request);
        req.then(response => {
            if (request.idEstado === idEstadoRebate.aprobado || request.idEstado === idEstadoRebate.aprobadoPorSeller) {
                toast.success("Rebate aprobado");
                setRebateState(prevState => ({ ...prevState, idEstadoRebate: request.idEstado }));
            } else {
                toast.success("Rebate desaprobado");
                setTieneRebate(false);
                setRebateState(prevState => ({
                    ...DEFAULT_REBATE,
                    precioFinal: publicacion.tieneRebate ? 0 : publicacion.precioLista,
                    porcentajesRebate: { ...prevState.porcentajesRebate }
                }));
            }
        }).catch(err => {
            (err.response?.data?.errors)
                ? err.response.data.errors.forEach(error => toast.warn(error))
                : toast.error("No pudo modificarse el estado");
        }).finally(() => {
            setIsLoading(false);
        });
    };

    const onSubmit = (event) => {
        event.preventDefault();

        const { precioFinal, aCargoMegatone, aCargoSeller, unidades, fechaInicio, fechaVencimiento, precioInicial } = rebateState;

        // --- NUEVAS VALIDACIONES ---
        const unidadesNum = unidades ? formatCurrencyToNumber(unidades) : 0;

        const isAllOk = validationsSubmitRebate({ precioFinal, aCargoMegatone, aCargoSeller, unidades, fechaInicio, fechaVencimiento, unidadesNum })
        if (!isAllOk) return;

        ///// agregue estas lineas
        let rebateRequest = {
            idPublicacion: publicacion.idPublicacion,
            precioFinal: precioFinal,
            aCargoMegatone: aCargoMegatone ?? null,
            aCargoSeller: aCargoSeller ?? null,
            idCategoryGeneraRebate: idUsuario,
            precioInicial: formatCurrencyToNumber(precioInicial),
        };

        // --- fechas y unidades ---
        if (fechaInicio && fechaVencimiento) {
            // Caso con fechas
            rebateRequest.fechaInicio = fechaInicio;
            rebateRequest.fechaVencimiento = fechaVencimiento;
            rebateRequest.unidades = null; // forzamos 0 o null ???????
        } else if (unidades && Number.parseInt(unidades) > 0) {
            //  Caso con unidades
            rebateRequest.unidades = Number.parseInt(unidades);
            rebateRequest.fechaInicio = null;      //// forzamos null o string ????????
            rebateRequest.fechaVencimiento = null;  //// forzamos null o string ????????
        }


        const rebate = sendOrUpdateRebate({ event, rebateRequest, publicacion, updateDataRebate, rebateState });
        if (rebate) {
            setRebateState(prevState => ({ ...prevState, rebate }));
        } else {
            setRebateState(prevState => ({ ...prevState, idEstadoRebate: 1 }));
            setTieneRebate(true);
        }
    }

    let precioFinalFormatted = formatoDecimal(rebateState.precioFinal);

    const porcentajeLabel = (valor) => (Number(valor) > 100 ? "Error" : `${valor}%`);

    return (
        <div
            className={`rebate-form-card card-rebate ${getTopColorClass({ userType, publicacion, rebate })}`}
            hidden={
                (userType.isSellerAdmin || userType.isSeller) && (!tieneRebate ||
                userType.isSellerAdmin) &&
                (rebate.idEstadoRebate === idEstadoRebate.aprobadoPorCategory ||
                    rebate.idEstadoRebate === idEstadoRebate.rechazado)
            }
        >
            {publicacion.tieneRebate
                && userType.isAdminMod
                && (rebateState.idEstadoRebate === idEstadoRebate.aprobado
                    || rebateState.idCategoryGeneraRebate !== 0)
                ? <h4 className="rebate-form-card__title text-themecolor color-verde-megatone">Rebate Enviado</h4>
                : <h4 className="rebate-form-card__title text-themecolor color-rojo-megatone">Nuevo Rebate</h4>
            }

            <div
                className="rebate-offer"
                hidden={!userType.isSellerAdmin || !tieneRebate || rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorCategory}
            >
                <div className="rebate-offer__summary">
                    <p hidden={!rebateState.fechaInicio} className="rebate-offer__dates">
                        {rebateState.fechaInicio} al {rebateState.fechaVencimiento}
                    </p>
                    <div className="rebate-offer__discount">
                        {rebateState.porcentajesRebate.porcentajeTotalDescuento} % OFF
                    </div>
                    <div className="rebate-offer__lines">
                        <p>
                            <strong>{rebateState.porcentajesRebate.porcentajeMegatone} %</strong>
                            ${rebateState.aCargoMegatone} a cargo del MegaMarket
                        </p>
                        <p>
                            <strong>{rebateState.porcentajesRebate.porcentajeSeller} %</strong>
                            ${rebateState.aCargoSeller} a cargo del Seller
                        </p>
                    </div>
                    <div className="rebate-offer__meta">
                        <span><strong>Precio final:</strong> ${rebateState.precioFinal}</span>
                        <span><strong>Unidades:</strong> {rebateState.unidades}</span>
                    </div>
                </div>

                {rebateState.idEstadoRebate !== idEstadoRebate.aprobadoPorSeller &&
                    <div className="rebate-offer__actions">
                        {isLoading ? <MiniSpinner /> :
                            <>
                                <button
                                    name="sellerAprove"
                                    onClick={onChangeState}
                                    className="btn btn-sm waves-light btn-green"
                                >
                                    Aceptar Oferta
                                </button>
                                <button
                                    name="decline"
                                    onClick={onChangeState}
                                    className="btn btn-sm background-rojo-megatone waves-light"
                                >
                                    Rechazar Oferta
                                </button>
                            </>
                        }
                    </div>
                }
            </div>

            {!userType.isSellerAdmin &&
                <div className="rebate-form">
                    <div className="rebate-form__grid">
                        <div className="rebate-form__field">
                            <label htmlFor="precioFinalRebate">Precio Final</label>
                            <div className="rebate-form__control">
                                <input
                                    id="precioFinalRebate"
                                    type="text"
                                    name="precioFinal"
                                    className="form-control"
                                    value={precioFinalFormatted}
                                    disabled
                                />
                                <span className="rebate-form__pct">
                                    {porcentajeLabel(rebateState.porcentajesRebate.porcentajeTotalDescuento)}
                                </span>
                            </div>
                        </div>

                        <div className="rebate-form__field">
                            <label htmlFor="aCargoMegatoneRebate">A cargo de Megatone</label>
                            <div className="rebate-form__control">
                                <input
                                    id="aCargoMegatoneRebate"
                                    type="number"
                                    className="form-control"
                                    disabled={publicacion.tieneRebate && userType.isSellerAdmin}
                                    value={rebateState.aCargoMegatone}
                                    onChange={myChangeAmount}
                                    name="aCargoMegatone"
                                    min="0"
                                />
                                <span className="rebate-form__pct">
                                    {porcentajeLabel(rebateState.porcentajesRebate.porcentajeMegatone)}
                                </span>
                            </div>
                        </div>

                        <div className="rebate-form__field">
                            <label htmlFor="aCargoSellerRebate">A cargo del seller</label>
                            <div className="rebate-form__control">
                                <input
                                    id="aCargoSellerRebate"
                                    type="number"
                                    className="form-control"
                                    disabled={publicacion.tieneRebate && userType.isSellerAdmin}
                                    value={rebateState.aCargoSeller ?? 0}
                                    onChange={myChangeAmount}
                                    name="aCargoSeller"
                                    min="0"
                                />
                                <span className="rebate-form__pct">
                                    {porcentajeLabel(rebateState.porcentajesRebate.porcentajeSeller)}
                                </span>
                            </div>
                        </div>

                        <div className="rebate-form__field">
                            <label className="label-oscura" htmlFor="fechaInicioRebate">Fecha Inicio</label>
                            <input
                                id="fechaInicioRebate"
                                type="date"
                                name="fechaInicio"
                                className={`form-control ${tieneRebate ? 'input-disabled' : ''}`}
                                onChange={myChangeHandler}
                                value={rebateState.fechaInicio}
                                disabled={tieneRebate}
                            />
                        </div>
                        <div className="rebate-form__field">
                            <label className="label-oscura" htmlFor="fechaVencimientoRebate">Fecha Vencimiento</label>
                            <input
                                id="fechaVencimientoRebate"
                                type="date"
                                name="fechaVencimiento"
                                className={`form-control ${tieneRebate ? 'input-disabled' : ''}`}
                                onChange={myChangeHandler}
                                value={rebateState.fechaVencimiento}
                                disabled={tieneRebate}
                            />
                        </div>
                        <div className="rebate-form__field">
                            <label htmlFor="unidades">Unidades</label>
                            <input
                                type="number"
                                id="unidades"
                                className="form-control"
                                disabled={tieneRebate && userType.isSellerAdmin}
                                value={rebateState.unidades}
                                onChange={myChangeHandler}
                                name="unidades"
                                min="0"
                            />
                        </div>
                    </div>

                    {(userType.isCategory || userType.isAdminMod) && !tieneRebate ?
                        <div className="rebate-form__actions">
                            <button
                                onClick={onSubmit}
                                name="send"
                                className="btn btn-sm background-rojo-megatone waves-light"
                            >
                                Enviar al administrador
                            </button>
                        </div> : <ButtonsForm userType={userType} rebateState={rebateState} idEstadoRebate={idEstadoRebate} onChangeState={onChangeState} onSubmit={onSubmit} rebate={rebate} onDelete={onDelete} />
                    }

                    {userType.isCategory ?
                        <p hidden={!tieneRebate} className="rebate-form__note text-secondary">Enviado rebate al administrador</p> :
                        <p hidden={rebateState.idAdminAprueba === 0} className="rebate-form__note text-secondary">Enviado rebate al seller</p>
                    }
                </div>
            }
        </div>
    );
}
Rebate.propTypes = {
    // Redux props
    publicacion: PropTypes.shape({
        idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        tieneRebate: PropTypes.bool,
        precioPromocional: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        precioLista: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
        isSeller: PropTypes.bool,
        isSellerAdmin: PropTypes.bool,
        isCategory: PropTypes.bool,
    }),
    idUsuario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    rebate: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        idAdminPrueba: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        rebate: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }),
        porcentajesRebate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        idEstadoRebate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    // Actions props
    updateDataRebate: PropTypes.func,
}

export default Rebate;